import { useCallback, useLayoutEffect, useRef } from 'react';
export var useEvent = function (callback) {
    var ref = useRef(function () {
        throw new Error('Cannot call an event handler while rendering.');
    });
    useLayoutEffect(function () {
        ref.current = callback;
    });
    return useCallback(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.apply(null, args);
    }, []);
};
